/** Convert a number to an alphabetic character
 *
 * ex: 0 -> 'A'
 *
 * ex: 1 -> 'B'
 */
export function convertNumberToAlpha(num: number): string {
  return String.fromCharCode(65 + num);
}

/**
 * Formats a number to a currency string with commas and a dollar sign.
 *
 * ex: 123456789 -> '$123,456,789'
 */
export function formatCurrency(value: number): string {
  const formattedValue = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  }).format(value);

  return formattedValue;
}
